import { faThList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateCounters() {
    return (
        <div data-cy="historic-icon-updateCountersAssign">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateCountersAssign" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faThList} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
